import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {blendColors} from '../../../libs/shared/core/src/models/helpers/colorHelpers';
import {ChromelessButton} from '../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon, IconName} from '../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {boxShadow} from '../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Props.
 */

interface StartGuideFooterLinkProps {
  iconName: IconName;
  className?: string;
  onClick: () => void;
}

/*
 * Style.
 */

const StyledButton = styled(ChromelessButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;

  background-color: ${(p) => p.theme.foreground};
  border: 1px solid ${(p) => p.theme.alphas.black30};
  ${(p) => boxShadow(p.theme, `0 1px 1px 0 ${p.theme.alphas.black10}`)};
  border-radius: 100px;

  &:hover {
    background-color: ${(p) => blendColors(p.theme.foreground, p.theme.alphas.gray10)};
  }
`;

const StyledButtonContentDiv = styled.div`
  display: grid;
  grid-template-columns: 16px auto;
  column-gap: 6px;
  grid-column-gap: 6px;
  line-height: 18px;
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.medium};
  align-items: center;

  svg {
    margin-left: -1px;
  }
`;

/*
 * Component.
 */

export const StartGuideFooterLink: FC<PropsWithChildren<StartGuideFooterLinkProps>> = (props) => (
  <StyledButton onClick={props.onClick} className={props.className}>
    <StyledButtonContentDiv>
      <Icon name={props.iconName} />
      {props.children}
    </StyledButtonContentDiv>
  </StyledButton>
);
